import React from "react";
import { useFeatureFlag } from "../../launch-darkly";
import { PersonalizedStatsRow } from "./PersonalizedStatsRow";
import { PersonalizedStatsRowGateway } from "./PersonalizedStatsRowGateway";

export function PersonalizedStats() {
  const [isUsingGateway] = useFeatureFlag("GatewayPersonalizedStats");
  return isUsingGateway ? <PersonalizedStatsRowGateway /> : <PersonalizedStatsRow />;
}
